import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import staffService from "services/StaffService";
import { message } from "antd";

export const initialState = {
  totalRecord: 0,
  loadingRoles: false,
  staffRoles: [],
  createLoading: [],
  loadingHrAsses: false,
  allHrAsses: [],
  loadingStaff: false,
  staff: [],
  // loadingStaff: false,
  technicalAss: [],
  loadingTechAss: false,
};

export const GetStaffSSR = createAsyncThunk(
  "/Account/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await staffService.GetStaffSSR(data);

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetTechnicalAssessment = createAsyncThunk(
  "/Account/GetTechnicalAssessment",
  async (_, { rejectWithValue }) => {
    try {
      const response = await staffService.GetTechnicalAssessment();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetHrAssessment = createAsyncThunk(
  "/Account/GetHRAssessment",
  async (_, { rejectWithValue }) => {
    try {
      const response = await staffService.GetHRAssessment();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetAllStaff = createAsyncThunk(
  "/Account/GetAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await staffService.GetAllStaff();

      return response.result;
      //   }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CreateStaff = createAsyncThunk(
  "/Account/CreateStaff",
  async (data, { rejectWithValue }) => {
    try {
      try {
        const response = await staffService.CreateStaff(data);

        if (response.success === false) {
          message.warning({
            content: ` ${response.message}`,
          });
          return rejectWithValue(response.message);
        } else {
          message.success({
            content: ` ${response.message}`,
          });

          return response;
        }
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message || "Something Went Wrong !"
        );
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetStaffById = createAsyncThunk(
  "/Account/GetById",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await staffService.GetStaffById({ userId });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const UpdateStaff = createAsyncThunk(
  "/Account/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await staffService.UpdateStaff(data);

      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetRoles = createAsyncThunk(
  "/Account/GetStaffRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await staffService.GetRoles();

      return response.result;
      //   }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetActive = createAsyncThunk(
  "/Account/SetIsActive",
  async ({ userId, status }, { rejectWithValue }) => {
    try {
      const response = await staffService.SetActive({ userId, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetStaffSSR.pending, (state) => {
        state.loadingStaff = true;
      })
      .addCase(GetStaffSSR.fulfilled, (state, action) => {
        state.loadingStaff = false;
        state.staff = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetStaffSSR.rejected, (state, action) => {
        state.staff = [];
        state.loadingStaff = false;
      })
      .addCase(GetRoles.pending, (state) => {
        state.loadingRoles = true;
      })
      .addCase(GetRoles.fulfilled, (state, action) => {
        state.loadingRoles = false;
        state.staffRoles = action.payload;
      })
      .addCase(GetRoles.rejected, (state, action) => {
        state.staffRoles = [];
        state.loadingRoles = false;
      })
      .addCase(CreateStaff.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(CreateStaff.fulfilled, (state, action) => {
        state.createLoading = false;
      })
      .addCase(CreateStaff.rejected, (state, action) => {
        state.createLoading = false;
      })
      .addCase(UpdateStaff.rejected, (state, action) => {
        state.loadingStaff = false;
      })
      .addCase(UpdateStaff.pending, (state) => {
        state.loadingStaff = true;
      })
      .addCase(UpdateStaff.fulfilled, (state, action) => {
        state.loadingStaff = false;
      })
      .addCase(GetAllStaff.pending, (state) => {
        state.loadingStaff = true;
        state.staff = [];
      })
      .addCase(GetAllStaff.fulfilled, (state, action) => {
        state.loadingStaff = false;
        state.staff = action.payload;
      })
      .addCase(GetAllStaff.rejected, (state, action) => {
        state.loadingStaff = false;
        state.staff = [];
      })
      .addCase(GetTechnicalAssessment.pending, (state) => {
        state.loadingTechAss = true;
      })
      .addCase(GetTechnicalAssessment.fulfilled, (state, action) => {
        state.loadingTechAss = false;
        state.technicalAss = action.payload;
      })
      .addCase(GetTechnicalAssessment.rejected, (state, action) => {
        state.loadingTechAss = false;
        state.allHrAsses = [];
      })
      .addCase(GetHrAssessment.pending, (state) => {
        state.loadingHrAsses = true;
      })
      .addCase(GetHrAssessment.fulfilled, (state, action) => {
        state.loadingHrAsses = false;
        state.allHrAsses = action.payload;
      })
      .addCase(GetHrAssessment.rejected, (state, action) => {
        state.loadingHrAsses = false;
        state.allHrAsses = [];
      });
  },
});

export const {} = staffSlice.actions;

export default staffSlice.reducer;
